<template>
    <div class="q-mt-xl text-center q-pb-md text-faded copyright-drawer">
        <small>Copyright © {{ (new Date()).getFullYear() }}: {{ getProjectName }} v{{ getVersion }} - Powered by <a href="https://take5.com.br">Take 5 LMS</a></small>
    </div>
</template>

<script>

export default {
    computed: {
        getProjectName() {
            return process.env.PROJECT_NAME
        },

        getVersion() {
            return process.env.APP_VERSION
        }
    }
}
</script>

<style lang="stylus" scoped>
a
    color #000000
    text-decoration none
</style>
